import { TextField } from "@material-ui/core"

export default function Comments() {
  return (
    <fieldset>
      <TextField label="Comments" name="comments" fullWidth multiline rows={4} variant="outlined" InputLabelProps={{ shrink: true }} />
    </fieldset>
  )
}


// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanApplication/components/Comments.js